import { render, staticRenderFns } from "./PublishProject.vue?vue&type=template&id=59e8d587&scoped=true"
import script from "./PublishProject.vue?vue&type=script&lang=js"
export * from "./PublishProject.vue?vue&type=script&lang=js"
import style0 from "./PublishProject.vue?vue&type=style&index=0&id=59e8d587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e8d587",
  null
  
)

export default component.exports